{
  "clientDeadlineDialog": {
    "title": "Add Deadline from Client",
    "close": "Close",
    "originalDate": "Original Date",
    "reason": "Reason",
    "requestedDeadline": "Requested Deadline",
    "requestedDeadlineError": "Requested deadline cannot be before original date",
    "comments": "Comments (optional)",
    "commentsPlaceholder": "Leave a comment",
    "save": "Save",
    "cancel": "Cancel"
  },
  "createInvoiceDialog": {
    "title": "Create Invoice",
    "close": "Close",
    "submit": "Submit",
    "cancel": "Cancel",
    "successMessage": "Invoice created successfully",
    "errorMessage": "Failed to create invoice. Please try again."
  },
  "cancelOrderDialog": {
    "text": "Are you sure you want to cancel this order?",
    "confirmButton": "Cancel Order",
    "cancelButton": "Keep Order"
  },
  "managePageContentDialog": {
    "title": "Manage page content",
    "subtitle": "Drag to rearrange the sections on the page.",
    "setAsDefault": "Set as default"
  },
  "reprojectDialog": {
    "title": "Reproject Order",
    "originalDate": "Original Date",
    "newDate": "New Projected Date",
    "reason": "Reason",
    "comments": "Comments (optional)",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "reasonRequired": "Reason is required",
    "newDateRequired": "New projected date is required"
  }
}
